/**
 * Change It Theme Plugin
 * Responsible for providing app level access to theme data
 */

import type { App, Plugin } from 'vue';
import type { Theme } from "./interfaces/theme";
import { useThemeStore } from "@/stores/theme";
import type { ThemeLabel } from "@/models/themeLabel";
import type { ThemeImage } from "@/models/themeImage";
import type { ThemeAnchor } from "@/models/themeAnchor";

const createThemeInstance = (): Theme => {

  return {
    getLabel: (key: string): ThemeLabel => {
      const themeStore = useThemeStore();
      const labels = themeStore.getTheme()?.labels;

      if (labels) {
        for (const label of labels) {
          if (label.key == key && label.value && label.value.length > 0) {
            return label;
          }
        }
      }

      // Fallback to default
      const defaultLabel: ThemeLabel = {
        key: key,
        value: 'default',
        css: ''
      };

      return defaultLabel;
    },
    getImage: (key: string): ThemeImage => {
      const themeStore = useThemeStore();
      const images = themeStore.getTheme()?.images;

      if (images) {
        for (const image of images) {
          if (image.key == key) {
            return image;
          }
        }
      }

      // Fallback to default
      const defaultImage: ThemeImage = {
        key: key,
        imagePath: '',
        css: '',
      }

      return defaultImage;
    },
    getAnchor: (key: string): ThemeAnchor => {
      const themeStore = useThemeStore();
      const anchors = themeStore.getTheme()?.anchors;

      if (anchors) {
        for (const anchor of anchors) {
          if (anchor.key == key) {
            return anchor;
          }
        }
      }

      // Fallback to default
      const defaultAnchor: ThemeAnchor = {
        key: key,
        href: '#',
        type: 'default',
        value: 'default',
        css: '',
      }

      return defaultAnchor;
    }
  }
}

const ThemePlugin: Plugin = {
  install(app: App)
  {
    const themeInstance = createThemeInstance();
    app.config.globalProperties.$theme = themeInstance;
    app.provide('theme', themeInstance);
  }
}

export default ThemePlugin;

// Augment global properties
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $theme: Theme;
  }
}